/**
* Generated by Kubb (https://kubb.dev/).
* Do not edit manually.
*/

import fetch from "../../../api-client";
import type { RequestConfig, ResponseErrorConfig } from "../../../api-client";
import type { GroupsControllerVerifyGroupMemberMutationResponse, GroupsControllerVerifyGroupMemberPathParams, GroupsControllerVerifyGroupMember400, GroupsControllerVerifyGroupMember401, GroupsControllerVerifyGroupMember403, GroupsControllerVerifyGroupMember404 } from "../../models/documentGroupsController/GroupsControllerVerifyGroupMember";

function getGroupsControllerVerifyGroupMemberUrl(groupId: GroupsControllerVerifyGroupMemberPathParams["groupId"], memberId: GroupsControllerVerifyGroupMemberPathParams["memberId"]) {
  const res = { method: 'POST', url: `/api/v1/documents/groups/${groupId}/members/${memberId}/verify` as const }  
  return res
}

/**
 * @description Marks an INFERRED membership USER_VERIFIED, after which inference treats it as user-owned. Verifying a BY_USER or already verified membership is a no-op that returns it unchanged.
 * @summary Verify an inferred membership
 * {@link /api/v1/documents/groups/:groupId/members/:memberId/verify}
 */
export async function groupsControllerVerifyGroupMember(groupId: GroupsControllerVerifyGroupMemberPathParams["groupId"], memberId: GroupsControllerVerifyGroupMemberPathParams["memberId"], config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const { client: request = fetch, ...requestConfig } = config  
  
  const res = await request<GroupsControllerVerifyGroupMemberMutationResponse, ResponseErrorConfig<GroupsControllerVerifyGroupMember400 | GroupsControllerVerifyGroupMember401 | GroupsControllerVerifyGroupMember403 | GroupsControllerVerifyGroupMember404>, unknown>({ method : "POST", url : getGroupsControllerVerifyGroupMemberUrl(groupId, memberId).url.toString(), ... requestConfig })  
  return res.data
}